// shared.module.ts
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TimeFormatPipe } from './time-format.pipe';
import { TimeFormatGhostPipe } from './time-format-ghost.pipe';
import { ThemePipe } from './theme.pipe';

@NgModule({
  imports: [IonicModule],
  declarations: [TimeFormatPipe, TimeFormatGhostPipe, ThemePipe],
  exports: [TimeFormatPipe, TimeFormatGhostPipe, ThemePipe],
})
export class PipeModule {}
